import React from 'react';

const Washington = () => {
  return (
    <div>
      
    </div>
  );
}

export default Washington;
